import { createGlobalStyle } from "styled-components"

import reset from "./reset"

const GlobalStyle = createGlobalStyle`
  ${reset}

  button {
    border: none;
    background: none;
  }

  html {
    font-family: poppins, sans-serif;
    font-size: 100%;
    // Offset sticky nav when clicking jump navs
    scroll-padding-top: 5rem;
  }

  // Prismic does not let you add sup and sub tags so adding via custom labels
  // which generates a span with a classname
  .superscript {
    vertical-align: super;
    font-size: 1.5rem;
  },

  .subscript {
    ertical-align: sub;
    font-size: smaller;
  }
`

export default GlobalStyle
